/*eslint-disable react/jsx-no-bind*/
import React from "react";
import { Row, Col, Table } from "react-bootstrap"
import { PropTypes } from 'prop-types'
import moment from 'moment'
import { red } from '../../../utils/constants'
import "react-table/react-table.css"

class DivisionsTable extends React.Component {
  constructor() {
    super();
    this.deleteAndRefreshDivision = this.deleteAndRefreshDivision.bind(this);
  }

  deleteAndRefreshDivision(id) {
    const { deleteDivision } = this.props;
    deleteDivision(id);
    refreshCurrentPage();
  }

  render() {
    const { divisions } = this.props;
    const divisionExist = (divisions !== undefined && divisions !== null) && (divisions.length > 0);

    return (
      (divisionExist) && (<Row>
        <Col xs={12}>
          <Table striped>
            <thead>
              <tr>
                <th>Division</th>
                <th>Name</th>
                <th>DOB Start</th>
                <th>DOB End</th>
                <th>Gender</th>
              </tr>
            </thead>
            <tbody>
              {
                (divisions !== undefined) && divisions.map((item, key) => (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{item.name}</td>
                    <td>{moment(item.dobStart).format('MM-DD-YYYY')}</td>
                    <td>{moment(item.dobEnd).format('MM-DD-YYYY')}</td>
                    <td>
                      <label className={`checkbox-inline c-checkbox`} style={{ color: 'rgb(0, 51, 141)', fontWeight: 'bold' }}>
                        <input type="checkbox" checked={item.boys === true} disabled />
                        <em className="fa fa-check" />&nbsp;Boys
                      </label>
                      <label className={`checkbox-inline c-checkbox`} style={{ color: 'rgb(0, 51, 141)', fontWeight: 'bold' }}>
                        <input type="checkbox" checked={item.girls === true} disabled />
                        <em className="fa fa-check" />&nbsp;Girls&nbsp;
                      </label>
                    </td>
                    <td>
                      <button type='button' className="btn btn-default" style={{ color: red, fontWeight: 800 }} onClick={() =>
                        this.deleteAndRefreshDivision(item.id)} >
                        <i className="fa fa-trash-o  text-muted mr-sm" aria-hidden="true" />&nbsp;Delete
                      </button >
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </Table>
        </Col>
      </Row>))
  }
}
DivisionsTable.propTypes = {
  divisions: PropTypes.object,
  deleteDivision: PropTypes.func
}
function refreshCurrentPage() {
  setTimeout(function () {
    window.location.reload();
  }, 2000);
}
export default DivisionsTable



// WEBPACK FOOTER //
// ./src/containers/season/components/DivisionsTable.js